import React from 'react';

import BusinessCustomSurveys from 'components/customSurvey/BusinessCustomSurveys';
import BusinessQuestions from 'components/businesses/tabs/questions/BusinessQuestions';
import BusinessReport from 'components/businesses/tabs/reports/BusinessReport';
import BusinessUsers from 'components/businesses/tabs/business-users/BusinessUsers';
import Redemption from 'containers/Redemption';
import RequestAddOns from 'components/businesses/tabs/info-edit/RequestAddOns';
import { getBusinessId } from 'constants/localStorageManager';
import BusinessProfile from 'containers/BusinessDetail';

export const BusinessDashboard = () => <div>Business Dashboard</div>;

export const BusinessDetails = () => (
  <div>
    <div className="container">
      <BusinessProfile />
    </div>
  </div>
);

export const BusinessRequestAddOns = () => (
  <div>
    <div className="container">
      <RequestAddOns editId={getBusinessId()} />
    </div>
  </div>
);

export const BusinessCustomSurvey = ({ setModalStatus }) => (
  <div className="container">
    <BusinessCustomSurveys
      setModalStatus={setModalStatus}
      editId={getBusinessId()}
    />
  </div>
);

export const BusinessQuestion = () => (
  <div className="container">
    <BusinessQuestions businessId={getBusinessId} />
  </div>
);

export const BusinessReports = () => (
  <div className="container">
    <BusinessReport businessId={getBusinessId} />
  </div>
);

export const BusinessUser = () => (
  <div className="container">
    <BusinessUsers businessId={getBusinessId} />
  </div>
);

export const BusinessRedemption = () => (
  <div className="container">
    <Redemption businessId={getBusinessId} />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Business-admin/MenuRedirect.js